import { render, staticRenderFns } from "./apple.vue?vue&type=template&id=202f8d4a&scoped=true&"
import script from "./apple.vue?vue&type=script&lang=js&"
export * from "./apple.vue?vue&type=script&lang=js&"
import style0 from "./apple.vue?vue&type=style&index=0&id=202f8d4a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202f8d4a",
  null
  
)

export default component.exports